<template>
  <material-card
    class="v-card--material-stats"
    v-bind="$attrs"
    :to="to"
    v-on="$listeners"
  >
    <template #subtitle>
      <count-to
        class="text-right text-h3 v-card__subtitle--material-stats"
        :start-val="0"
        :end-val="Number(value)"
        :duration="1000"
        :prefix="prefix"
        :suffix="suffix"
        :decimals="decimals"
        separator="."
        decimal=","
      />

      <!-- <div
        class="text-right text-h3 v-card__subtitle--material-stats"
        v-text="value"
      /> -->
    </template>

    <template #actions>
      <slot name="actions" />
    </template>

    <slot />
  </material-card>
</template>

<script>
  import CountTo from 'vue-count-to/src'

  export default {
    name: 'MaterialStatCard',

    components: { CountTo },

    props: {
      value: [String, Number],
      prefix: String,
      suffix: String,
      decimals: Number,
      to: String,
    },
  }
</script>

<style lang="sass">
.v-card--material-stats.v-card--material .v-card--material__title
  color: #999999
  font-size: .875rem !important
  margin-left: auto
  text-align: right

.v-card__subtitle--material-stats
  color: #3C4858
  font-size: 1.6rem !important
  line-height: 1.1

.v-card--material-stats .v-card__actions
  min-height: 42px
  padding-top: 6px !important
  padding-bottom: 8px !important
  align-items: center
</style>
